import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ApiHelperFunction from "../../api";

interface ITINPayload {
  has_us_company: boolean;
  status: boolean;
  business_incorporation?: string;
  ein_document?: string;
  scan_passport?: string;
  w7_form?: string;
  extract_data?: {};
  form_2848?: string;
}

interface APIResponse {
  status: number;
  message: string;
  data?: any;
}

export const getOrderList = createAsyncThunk(
  "admin/get-order-details",
  async (
    {  userId,
      offset = 0,
      limit = 10,
      start_date = "",
      search = "",
    }: { offset?: number; limit?: number; userId?: number; search: "", start_date?: string },
    { dispatch }
  ) => {
    const token = localStorage.getItem("user_token");

    const queryParams = new URLSearchParams({
      offset: offset.toString(),
      limit: limit.toString(),
    });
    if (search) {
      queryParams.append("search", search);
    }
    if(start_date){
      queryParams.append("start_date", start_date);
    }
   
    const response = await ApiHelperFunction({
      url: `get-orders-list/${userId}?order_type=itin&${queryParams}`,
      method: "get",
      dispatch,
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? `${token}` : "",
      },
    });

    return {
      data: response?.data?.data || [],
      total_records: response?.data?.total_records || 0,
    };
  }
);

export const createUpdateItin = createAsyncThunk(
  "itin/create-report/",
  async (payload: any, { dispatch, rejectWithValue }) => {
    const token = localStorage.getItem("user_token");

    const formData = new FormData();

    Object.keys(payload).forEach((key) => {
      if (payload[key]) {
        formData.append(key, payload[key]);
      }
    });

    try {
      const response = await ApiHelperFunction({
        url: "/itin/create-report/",
        method: "post",
        data: formData,
        dispatch,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: token ? `${token}` : "",
        },
      });

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const createUpdateItinSignature = createAsyncThunk(
  "itin/create-report/",
  async (payload: any, { dispatch, rejectWithValue }) => {
    const token = localStorage.getItem("user_token");
    const formData = new FormData();


    Object.keys(payload).forEach((key) => {
      const value = payload[key];

      if (value !== undefined && value !== null) {
        if (key === "form_2848_signed_form" && value instanceof File) {
          formData.append("form_2848_signed_form", value, value.name);
        } else if (key === "w7_signed_form" && value instanceof File) {
          formData.append("w7_signed_form", value, value.name);
        } else if (typeof value === "object" && !(value instanceof File)) {
          formData.append(key, JSON.stringify(value));
        } else {
          formData.append(key, value);
        }
      }
    });

    try {
      const response = await ApiHelperFunction({
        url: "/itin/create-report/",
        method: "post",
        data: formData,
        dispatch,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: token ? `${token}` : "",
        },
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const createUpdateItinW7 = createAsyncThunk(
  "itin/create-report-w7/",
  async (payload: any, { dispatch, rejectWithValue }) => {
    const token = localStorage.getItem("user_token");
    const formData = new FormData();

    console.log("🚀 Incoming Payload in Thunk:", payload);

    Object.keys(payload).forEach((key) => {
      const value = payload[key];

      if (value !== undefined && value !== null) {
   
        if (key === "w7_form" && value instanceof File) {
       
          formData.append("w7_form", value, value.name); 
        } else if (typeof value === "object" && !(value instanceof File)) {
        
          formData.append(key, JSON.stringify(value));
        } else {
       
          formData.append(key, value);
        }
      }
    });

    try {
      const response = await ApiHelperFunction({
        url: "/itin/create-report/",
        method: "post",
        data: formData,
        dispatch,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: token ? `${token}` : "",
        },
      });
      return response.data;
    } catch (error: any) {

      return rejectWithValue(error);
    }
  }
);



export const createUpdateItinW848 = createAsyncThunk(
  "itin/create-report/",
  async (payload: any, { dispatch, rejectWithValue }) => {
    const token = localStorage.getItem("user_token");
    const formData = new FormData();
    Object.keys(payload).forEach((key) => {
      const value = payload[key];

      if (value !== undefined && value !== null) {
        if (key === "form_2848_file" && value instanceof File) {
          // The browser-rendered 2848 PDF, same as w7_form / ein_form_file.
          formData.append("form_2848_file", value, value.name);
        } else if (key === "form_2848" && value instanceof File) {

          formData.append("form_2848", value, value.name);
        } else if (typeof value === "object" && !(value instanceof File)) {
       
          formData.append(key, JSON.stringify(value));
        } else {
       
          formData.append(key, value);
        }
      }
    });

    try {
      const response = await ApiHelperFunction({
        url: "/itin/create-report/",
        method: "post",
        data: formData,
        dispatch,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: token ? `${token}` : "",
        },
      });

   
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const getItin = createAsyncThunk(
  "get-itin-data/",
  async (payload: any, { dispatch, rejectWithValue }) => {
    const token = localStorage.getItem("user_token");
    try {
      const response = await ApiHelperFunction({
        url: "get-itin-data/",
        method: "get",
        dispatch,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: token ? `${token}` : "",
        },
      });

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const getItinData = createAsyncThunk(
  "get-itin-data/",
  async (payload:   { order_id: string | undefined }, { dispatch, rejectWithValue }) => {
    const token = localStorage.getItem("user_token");
    try {
      const response = await ApiHelperFunction({
        url: `get-itin-data/?order_id=${payload.order_id ?? ""}`,
        method: "get",
        dispatch,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: token ? `${token}` : "",
        },
      });

      return response?.data?.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);


export const uploadFile = createAsyncThunk(
  "/extract-data/",
  async (payload: any, { dispatch, rejectWithValue }) => {
    const token = localStorage.getItem("user_token");

    const formData = new FormData();

    Object.keys(payload).forEach((key) => {
      if (payload[key] instanceof File) {
        formData.append(key, payload[key], payload[key].name);
      } else if (payload[key]) {
        formData.append(key, payload[key]);
      }
    });

  
    Array.from(formData.entries()).forEach(([key, value]) => {
     
    });

    try {
      const response = await ApiHelperFunction({
        url: "/extract-data/",
        method: "post",
        data: formData,
        dispatch,
        headers: {
          Authorization: token ? `${token}` : "",
        },
      });

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const dashboard = createAsyncThunk(
  "dashboard",
  async (payload: any, { dispatch, rejectWithValue }) => {
    const token = localStorage.getItem("user_token");
    const formData = new FormData();

    console.log("🚀 Incoming Payload in Thunk:", payload);

    Object.keys(payload).forEach((key) => {
      const value = payload[key];

      if (value !== undefined && value !== null) {
        if (key === "form_2848_signed_form" && value instanceof File) {

          formData.append("form_2848_signed_form", value, value.name);
        } else if (key === "w7_signed_form" && value instanceof File) {

          formData.append("w7_signed_form", value, value.name);
        } else if (typeof value === "object" && !(value instanceof File)) {

          formData.append(key, JSON.stringify(value));
        } else {

          formData.append(key, value);
        }
      }
    });

    try {
      const response = await ApiHelperFunction({
        url: "dashboard",
        method: "get",

        dispatch,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: token ? `${token}` : "",
        },
      });

   
      return response.data;
    } catch (error: any) {

      return rejectWithValue(error);
    }
  }
);
export const updateItinAddress = createAsyncThunk(
  "itin/update-itin-application-data",
  async (
    payload: {
      order_id: any;
      address: string;
      city: string;
      state: string;
      zip_code: string;
      country: string;
      phone_number: string;
    },
    { dispatch, rejectWithValue }
  ) => {
    const token = localStorage.getItem("user_token");

    try {
      const response = await ApiHelperFunction({
        url: "update-itin-application-data/",
        method: "post",
        data: payload,
        dispatch,
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `${token}` : "",
        },
      });

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

interface ITINState {
  status: "idle" | "loading" | "succeeded" | "failed";
  addressStatus?: "idle" | "loading" | "succeeded" | "failed";
  userData: any;
  formattedData: any;
  error: string;
  total_records?: number;
  records_limit?: number;
  data: any[];
}

const initialState: ITINState = {
  status: "idle",
  userData: null,
  formattedData: null,
    addressStatus: "idle",
  error: "",
  data: [],
  total_records: 0,
  records_limit: 10,
  
};

export const itinSlice = createSlice({
  name: "itin",
  initialState,
  reducers: {
    resetAll: (state) => {
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createUpdateItin.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createUpdateItin.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.userData = action.payload;
      })
      .addCase(createUpdateItin.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      })
      .addCase(uploadFile.fulfilled, (state, action) => {
        state.formattedData = action.payload.extracted_data?.passport || {};
      })
      .addCase(createUpdateItinW7.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createUpdateItinW7.fulfilled, (state, action) => {
        state.status = "succeeded";
        // state.userData = action.payload;
      })
      .addCase(createUpdateItinW7.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      })
      // ✅ Get order List
      .addCase(getOrderList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getOrderList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload.data;
        state.total_records = action.payload.total_records;
      })
      .addCase(getOrderList.rejected, (state, action) => {
        state.status = "failed";
        // state.error = action.error.message;
      })
      // ✅ Get itin data
      .addCase(getItinData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getItinData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload.data;
      
       
      })
      .addCase(getItinData.rejected, (state, action) => {
        state.status = "failed";
       
      })
        .addCase(updateItinAddress.pending, (state) => {
        state.addressStatus = "loading";
      })
      .addCase(updateItinAddress.fulfilled, (state, action) => {
        state.addressStatus = "succeeded";
      })
      .addCase(updateItinAddress.rejected, (state, action) => {
        state.addressStatus = "failed";
      });
  },
});

export const { resetAll } = itinSlice.actions;
export default itinSlice.reducer;
